<template>
    <div
     class="stuClassroom"
     v-loading="loading"
     element-loading-text="正在加载教室，请稍候"
     element-loading-background="rgba(255, 255, 255, 0.9)"
    >
        <classroomHeader
         type="student" 
         :lessonTime="lessonTime" 
         :teduBoard="teduBoard"
         :lessonType="lessonType"
         @handlerStuTab="handlerStuTab"
         :cameraStream="cameraStream"></classroomHeader>
        <div class="classroomBody">
            <audio :src="voiceUrl"></audio>
            <div class="boardBox">
                <div v-show="classData.currentTab == 'board' && !screenShare" style="width: 100%; height: 100%">
                    <div class="masking" oncontextmenu="return false;"></div>
                    <PanoWhiteboard />
                </div>
                <MainView v-if="screenShare" />
                <LiveLoading v-if="lessonLoading && lessonTab == 'lesson'"></LiveLoading>
                <iframe id="scIframe" v-if="lessonType == 'scratch' && scratchPostMessage || classData.currentTab == 'editor_scratch'" v-show="classData.currentTab == 'editor_scratch'" width="100%" height="100%" :src="`https://${hostname}/scratch${worksId? '?worksId='+worksId+'&live=1&timestamp='+timestamp : '?live=1'}`" frameborder="0"></iframe>
                <iframe id="pyIframe" v-if="lessonType == 'python'" v-show="classData.currentTab == 'editor_python'" width="100%" height="100%" :src="`https://${hostname}/python${worksId? '?worksId='+worksId+'&lessonId='+ lessonId + '&timestamp='+timestamp : '?lessonId='+lessonId}`" frameborder="0"></iframe>
            </div>
            <div class="userListBox">
                <SmallVideoList />
                <ChatArea
                 v-if="roomSuccess" 
                 ref="chatArea"
                 :enableChat="enableChat"
                 @handlerStuSaveWorksFn="handlerStuSaveWorks"
                 @stuLoadWork="stuLoadWork"
                 @chatSwitch="chatSwitch"
                 @changeTab="changeTab"
                 @defaultSettings="defaultSettings"
                 @stopClass="stopClass"/>
            </div>
            <!-- <div class="userListBox">
                <div style="position: relative;">
                    <div
                     id="video_teacher_list"
                     v-loading="teaVideoLoading"
                     element-loading-text="视频切换中"
                     element-loading-background="rgba(0, 0, 0, 0.8)">
                        <div
                         class="teacher_video"
                         v-for="(item, index) in teacherRemoteStreamList"
                         :key="index"
                         :id="item.stream.getId()">
                            <img v-show="teaDefaultVideoImg" :src="tecDefaultBg" class="defaultBg" alt="">
                            {{ currentVideoPlay(item, index) }}
                            <span class="teacher_name">{{ item.name }}</span>
                        </div>
                        <img style="width: 100%; height: 180px;" v-if="screenStreamList.length" src="@/assets/tic/shareview.png" alt="">
                    </div>
                    <div id="video_student_list" :class="oneselfPlatform? 'platform' : ''">
                        <div
                         :class="item.id == 'i'? 'my_video student_video' : 'student_video'"
                         v-for="(item, index) in stuRemoteStreamList"
                         :key="index"
                         :id="item.stream.getId()"
                         oncontextmenu="return false;"
                         @mouseenter="student_control_show = item.id"
                         @mouseleave="student_control_show = ''">
                            {{ currentVideoPlay(item, index) }}
                            <img v-show="!item.video" :src="stuDefaultBg" class="defaultBg" alt="">
                            <span v-if="item.id !== 'i'" class="student_name">{{ item.name }}</span>
                            <div class="student_control" v-show="(item.id == 'i') && student_control_show == item.id">
                                <el-tooltip content="视频开关" placement="top" effect="light">
                                    <img
                                     :src="item.video? videoIcon[0] : videoIcon[1]"
                                     @click="e => handlerStuVideo(item, index)">
                                </el-tooltip>
                                <el-tooltip content="麦克风开关" placement="top" effect="light">
                                    <img
                                     :src="isAudioPush? audioIcon[0] : audioIcon[1]" 
                                     @click="e => handlerStuAudio(!isAudioPush)">
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="(oneselfPlatform || stuRemoteStreamList.length > 1)? 'functional_region platformTrue' : 'functional_region'">
                    <div class="functional_region_tab">
                        <el-badge
                         v-for="(item, index) in fun_tab" 
                         :key="index"
                         :class="fun_tab_active == item.text? 'active functional_region_tab——item' : 'functional_region_tab——item'"
                         is-dot 
                         :hidden="item.hidden"
                         @click.native="changeFunctionalTab(item, index)">
                            <span>{{ item.text }}</span>
                        </el-badge>
                    </div>
                    <ChatArea
                     v-show="fun_tab_active == '消息'"
                     :msgs="msgs"
                     :userId="userLogin.userId"
                     :imMsg="imMsg"></ChatArea>
                    <StudentList :userList="cacheStuRemoteStreamList" v-show="fun_tab_active == '同学'"></StudentList>
                    <FileList :fileList="files" v-show="fun_tab_active == '文件'"></FileList>
                    <div class="functional_region_foot">
                        <div class="functional_region_foot_tab">
                            <div class="flex_row">
                                <Emoji :enableChat="enableChat" @sendEmojiMessage="sendEmojiMessage"></Emoji>
                                <el-tooltip content="发送语音（按住说话，松开发送）" placement="top" effect="light">
                                    <span
                                     class="voiceIcon"
                                     @mousedown.left="handlerVoicePlay"
                                     @mouseup.left="handlerVoiceStop"
                                     @mouseout="handlerVoiceStop"></span>
                                </el-tooltip>
                                <PicUpload :enableChat="enableChat" @imgUploadSuccess="imgUploadSuccess"></PicUpload>
                            </div>
                            <div class="hands_btn_box">
                                <div class="hands_btn" @click="raiseHand">
                                    <el-tooltip content="举手上台" placement="top" effect="light">
                                        <img src="@/assets/tic/stuhand.png" alt="">
                                    </el-tooltip> 
                                </div>
                            </div>
                        </div>
                        <div v-if="input_speak == 'speak'">
                            <SpeakLoading :isplay="speckLoadingPlay"></SpeakLoading>
                        </div>
                        <div class="commonBox" v-if="input_speak == 'input'">
                            <el-input
                             type="textarea"
                             rows="2"
                             :placeholder="enableChat? '请输入内容' : '当前禁言'"
                             v-model="msgContent"
                             resize="none"
                             maxlength="50"
                             :disabled="!enableChat"
                             @keydown.enter.native="sendMsg">
                            </el-input>
                            <el-button :disabled="!enableChat" type="primary" @click="sendMsg">发送</el-button>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <!-- 发卡片 -->
        <CardAnimation ref="cardAnimationRef" :img="awardCardImg"></CardAnimation>
        <promptChangedDialog
         :promptShow="promptShow"
         @saveWork="onSaveWork"
         @unSaveWork="onUnSaveWork"
         @cancel="onCancel"
        ></promptChangedDialog>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import MainView from "./components/userVideo/MainView";
import SmallVideoList from "./components/SmallVideoList";
import PanoWhiteboard from "./components/whiteboard/PanoWhiteboard";
import MeetingInfo from "./components/MeetingInfo";
import { applyForWbAdmin } from "./setup-panortc";
import panoApi from "@/request/api/pano";
import tencentApi from "@/request/api/tencent";
import initPanoRtc from "./setup-panortc";
import * as Constants from "./constants";
import PanoRtc from "@pano.video/panortc";
import Setting from "./components/Setting";


import ClassroomHeader from './components/classroomHeader';
import CardAnimation from './components/cardAnimation';
import Emoji from './components/emoji.vue';
import SpeakLoading from './components/speakLoading.vue';
import ChatArea from './components/chatArea';
import PicUpload from './components/picUpload';
import Recorder from 'js-audio-recorder';
import fileApi from '@/request/api/file';
import FileList from './components/fileList.vue';
import StudentList from './components/studentList.vue';
import classApi from '@/request/api/class';
import promptChangedDialog from './components/promptChangedDialog';
import LiveLoading from '@/components/live-loading';

export default {
    components: { 
        ClassroomHeader, 
        CardAnimation, 
        Emoji, 
        SpeakLoading, 
        ChatArea, 
        PicUpload, 
        FileList,
        StudentList,
        promptChangedDialog,
        LiveLoading,
        SmallVideoList,
        PanoWhiteboard,
        MainView,
        MeetingInfo,
        Setting,
    },
    computed: {
        ...mapGetters([
            "isWhiteboardOpen",
            "userMe",
            "whiteboardUpdated",
            "wbAdminUser",
            "meetingStatus",
            "meetingEndReason",
            "videoPorfile",
            "whiteboardAvailable",
            "lessonDocId",
            "classData",
            "name",
            "screenShare",
            "definedMsg",
            "lessonLoading"
        ])
    },
    data() {
        return {
            //账号信息
            userLogin: {
                userId: "",
                userSig: '',
            },
            cameraStream: null, //本地视频流
            classId: "",
            teacherId: "",
            lessonTime: "",
            //当前用户状态
            STATUS_UNINIT: 0,
            STATUS_UNLOGIN: 1,
            STATUS_LOGINED: 2,
            STATUS_INCLASS: 3,
            status: 0,
            isPushing: 0, // 是否正在推流

            hostname: location.hostname,
            lessonTab: 'lesson',
            //board(白板操作)
            boardData: {
                currentBoardId: null, //当前白板ID
                boardIdlist: [], //白板ID列表
                current: 0, //当前白板index
                total: 0 //总页数
            },
            //board(文件操作)
            currentFileId: null, // 当前文件Id
            fileInfoList: [], // 所有文件信息
            thumbUrls: [], // 缩略图
            //消息
            msgs: [],
            imMsg: {
                common: {},
                custom: {}
            },
            directiveMsg: "",
            showScreen: false,
            showBoard: true,
            teduBoard: "",
            stuRemoteStreamList: [],
            cacheStuRemoteStreamList: [],
            teacherRemoteStreamList: [],
            videoIcon: [require('@/assets/tic/video.png'), require('@/assets/tic/video_close.png')],
            audioIcon: [require('@/assets/tic/audio.png'), require('@/assets/tic/audio_close.png')],
            isVideoPush: true, //视频流是否播放
            isAudioPush: true, //音频是否播放
            student_control_show: false,
            teacherStreamType: "",
            screenStreamList: "",
            screenTnstruct: false,
            streamTnstruct: false,
            teacherRemoteStream: "",
            teacherUserData: "",
            scratchPostMessage: false,
            worksId: "",
            timestamp: "",
            lessonName: "", //课程名，作品保存名称
            awardCardImg: "", //奖励卡片url
            fun_tab: [
                {
                    text: '消息',
                    hidden: true
                }, {
                    text: '同学',
                    hidden: true
                }, {
                    text: '文件',
                    hidden: true
                }
            ],
            fun_tab_active: "消息",
            commonBoxShow: false, //聊天input
            speckLoadingPlay: false,
            recorder: new Recorder(),
            voiceTime: 0,
            voiceUrl: "",
            input_speak: 'input',
            files: [],
            platformStatus: false,
            msgContent: "", //消息内容
            lessonType: "", //判断是否为编程课
            shareScreen: false,
            enableChat: true, //是否允许聊天
            oneselfPlatform: false, //上台
            loading: true,
            teaVideoLoading: false, 
            promptChanged: false,
            promptShow: false,
            currentWorkId: "",
            tecLookWork: false, //老师查看程序
            currentPythonCode: "",
            loginStatus: false,
            lessonId: "",
            tecDefaultBg: require('@/assets/tic/tecdefault.png'),
            stuDefaultBg: require('@/assets/tic/studefault.png'),
            teaDefaultVideoImg: true,

            roomSuccess: false,
            appId: "a21e24a59b2042de9fb898f1102d2132",
            form: {
                audioOn: true,
                videoOn: true
            },
        }
    },
    watch: {
        screenTnstruct() {
            this.setTeacherStream();
        },
        streamTnstruct() {
            this.setTeacherStream();
        },
        // fun_tab_active() {
        //     this.commonBoxShow = false;
        // },
    },
    beforeDestroy() {
        console.log("销毁")
        this.quitClassroom();
    },
    async created() {
        await this.getUser();
        this.classData.token = await this.getToken();
        this.roomSuccess = true;
        initPanoRtc();
        this.form.audioOn = !this.userMe.audioMuted;
        this.form.videoOn = !this.userMe.videoMuted;
        window.rtcEngine.on(
            PanoRtc.RtcEngine.Events.joinChannelConfirm,
            this.onJoinChannelConfirm
        );
        this.joinChannel();
        window.addEventListener('message', e => this.messageListener(e))
        // this.getUserConfig();
    },
    methods: {
        ...mapMutations([
            "updateUser",
            "setWhiteboardOpenState",
            "resetUserStore",
            "resetMeetingStore",
            "setSettingVisible",
            "updateChannelId",
            "updateUserMe",
            "setMeetingStatus",
            "setLessonDocId",
            "setClassData"
        ]),
        async getUserConfig() {
            await this.getUser()
            this.init();
        },
        //获取当前登录信息
        getUser(time=false) {
            return new Promise((resolve) => {
                if(this.$route.query && this.$route.query.id) {
                    tencentApi.getClassData(this.$route.query.id, time, res => {
                        if(res.succeed) {
                            this.setClassData({
                                ...this.classData,
                                id: this.$route.query.id,
                                ppdId: (res.data.lesson && res.data.lesson.panoDocId)? res.data.lesson.panoDocId : '',
                                userId: res.data.userId,
                                userSig: res.data.userSig,
                                channelId: String(res.data.classId),
                                userName: this.name,
                                teacherId: res.data.teacherId,
                                currentTab: 'board'
                            })
                            this.lessonTime = res.data.clickClassTime;
                            // if(res.data.clickClassTime) {
                            //     this.lessonTime = res.data.clickClassTime;
                            // } else if(time) {
                            //     this.lessonTime = res.data.clickClassTime;
                            //     resolve(true)
                            //     return;
                            // }
                            // this.userLogin.userId = res.data.userId;
                            // this.userLogin.userSig = res.data.userSig;
                            // this.classId = res.data.classId;
                            // this.teacherId = res.data.teacherId;
                            // this.lessonTime = res.data.clickClassTime;
                            this.lessonName = res.data.lesson? res.data.lesson.name : '';
                            this.lessonType = res.data.lesson? res.data.lesson.lessonType : "";
                            // this.lessonId = res.data.lesson? res.data.lesson.id : "";
                            // // this.lessonType = "python";
                            resolve(true)
                        }
                    })
                }
            })
        },
        getToken() {
            return new Promise((resolve) => {
                let params = {
                channelId: this.classData.channelId,
                userId: this.classData.userId,
                };
                panoApi.getToken(params, (res) => {
                console.log(res);
                if (res.succeed) {
                    resolve(res.data);
                }
                });
            });
        },
        async joinChannel() {
            const { channelId, userName, userId, token } = this.classData;
            console.log(channelId, userName, userId);
            if (!channelId || !this.appId || !userId || !token) {
                this.$message.warning("请填写必要的参数再加入会议");
                return;
            }
            localStorage.setItem(Constants.localCacheKeyUserName, userName);
            localStorage.setItem(Constants.localCacheKeyChannelId, channelId);
            this.loading = true;
            this.updateChannelId(channelId);
            this.updateUserMe({
                userName,
                userId,
            });
            console.log("joinChannel...");
            window.rtcEngine.joinChannel({
                appId: this.appId,
                token,
                channelId,
                channelMode: Constants.ChannelMode.TYPE_MEETING,
                userId,
                userName,
                joinChannelType: PanoRtc.Constants.JoinChannelType.mediaAndWhiteboard,
            },
            {
                joinChannelType: PanoRtc.Constants.JoinChannelType.mediaAndWhiteboard,
            });
            // window.rtcWhiteboard.joinChannel(
            //   {
            //     appId,
            //     token,
            //     channelId,
            //     name: userName,
            //     userId
            //   },
            //   () => {},
            //   () => {}
            // );
        },
        /**
         * 入会成功回调
         */
        onJoinChannelConfirm(data) {
            console.log(data, audioOn, videoOn);
            this.loading = false;
            const { audioOn, videoOn } = this.form;
            if (data.result === "success") {
                // this.onClickWhiteboard();
                this.clock();
                if (audioOn) {
                    window.rtcEngine.startAudio();
                }
                if (videoOn) {
                    window.rtcEngine.startVideo(this.videoPorfile);
                }
                localStorage.setItem(Constants.localCacheKeyMuteMicAtStart,audioOn ? "no" : "yes");
                localStorage.setItem(Constants.localCacheKeyMuteCamAtStart,videoOn ? "no" : "yes");
                this.updateUserMe({ audioMuted: !audioOn, videoMuted: !videoOn });
                this.setMeetingStatus("connected");
                // this.$router.replace({ name: 'Meeting' });
            } else {
                this.$message.error("joinChannel Failed " + data.message);
            }
        },
        stopClass() {
            clearInterval(this.dotInterval)
            this.$confirm('老师已下课，是否离开教室？', '提示', {
                confirmButtonText: '离开',
                cancelButtonText: '不离开',
                type: 'warning'
            }).then(async() => {
                window.rtcEngine.destroy();
                console.log("执行了啊!")
                window.location.replace(location.origin + '/personhome') 
            }).catch(async(err) => {
                console.log("????????", err)
                window.rtcEngine.destroy();
            });
        },
        onClickWhiteboard() {
            if (!this.whiteboardAvailable) {
                this.$message.info('白板尚未准备好，请稍后重试');
                return;
            }
            console.log('isWhiteboardOpen', this.isWhiteboardOpen)
                this.setWhiteboardOpenState(!this.isWhiteboardOpen);
        },
        quitClass(next) {
            clearInterval(this.dotInterval)
            this.tic.quitClassroom(async res => {
                if (res.code) {
                    console.log('quitClassroom error' + res.code);
                    this.clearClassInfo();
                    await this.logout();
                    next(true);
                } else {
                    this.initData();
                }
            });
        },
        //监听postMessage消息
        messageListener(e) {
            if(e.data == 'loadComplete') {
                this.scratchPostMessage = true;
            } else if(typeof e.data == 'string' && (e.data.startsWith("{") && e.data.endsWith("}"))) {
                console.log(e)
                if(JSON.parse(e.data).messge && JSON.parse(e.data).messge == 'worksId') {
                    console.log(this.tecLookWork)
                    if(this.tecLookWork) {
                        this.saveWorksAccomplish(JSON.parse(e.data).worksId);
                        this.tecLookWork = false;
                        return;
                    }
                    console.log(this.lessonType == 'python', this.currentPythonCode)
                    if(this.lessonType == 'scratch') {
                        this.loadWork();
                    } else if(this.lessonType == 'python' && this.currentPythonCode) {
                        this.loadPythonCode();
                    }
                } else if(JSON.parse(e.data).messge && JSON.parse(e.data).messge == 'projectChanged') {
                    this.promptChanged = true;
                } else if(JSON.parse(e.data).messge && JSON.parse(e.data).messge == 'projectUnchanged') {
                    this.promptChanged = false;
                } else if(JSON.parse(e.data).messge && JSON.parse(e.data).messge == 'pythonCode') {
                    this.definedMsg('stuPythonCode', 'fn', this.classData.teacherId, JSON.parse(e.data).content)
                }
            }
        },
        //转rgba
        hexToRgba(hex, opacity) {
            return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ','
              + parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')';
        },
        //打点
        clock() {
            classApi.clockIn({
                "userId": this.classData.userId,
                "userType": 2,
                "courseId": this.$route.query.id, 
                "timestamp": Date.parse(new Date()) / 1000 + '',
                "MACAddress": "0.0.0.0"
            }, res => {
                console.log(res)
            })
        },
        // 启动推流(推摄像头)
        startRTC() {
            // 从麦克风和摄像头采集本地音视频流
            this.cameraStream = TRTC.createStream({
                audio: true,
                video: true
            });
            // 设置视频分辨率等参数
            this.cameraStream.setVideoProfile('480p');
            if (this.localStream && this.isPushing) { // 如果正在推流, 先停止发布流
                this.stopPush(() => {
                    this.publishLocalStream(this.cameraStream);
                });
            } else {
                this.publishLocalStream(this.cameraStream);
            }
        },
        /**
        * 麦克风开关
        */
        toggleMic() {
            this.enableMic = !this.enableMic
            if (this.localStream) {
                this.localStream.muteAudio()
            }
        },
        //切换tab
        handlerStuTab(value) {
            this.lessonTab = value;
        },
        //切换功能tab
        changeFunctionalTab(item, index) {
            console.log(item, index)
            this.fun_tab_active = item.text;
            this.$set(this.fun_tab[index], 'hidden', true);
        },
        //跟随老师切换
        changeTab(type) {
            console.log(type)
            this.setClassData({
                ...this.classData,
                currentTab: type
            })
        },
        //教师查看当前程序
        async handlerStuSaveWorks() {
            this.tecLookWork = true;
            if(this.lessonType == 'scratch') {
                let scIframe = document.getElementById('scIframe').contentWindow;
                scIframe.postMessage(`saveWorks#${this.lessonName}`, '*');
            } else if(this.lessonType == 'python') {
                let pyIframe = document.getElementById('pyIframe').contentWindow;
                // pyIframe.postMessage(`lookCode`, '*');
                let code = await this.getPythonCode();
                this.definedMsg('stuPythonCode', 'fn', this.classData.teacherId, code)
            }
        },
        //获取py代码
        getPythonCode(){
            return new Promise((resolve, reject)=>{
                let pyIframe = document.getElementById('pyIframe').contentWindow;
                pyIframe.postMessage(`lookCode`, '*');
                let data = pyIframe.saveWorks();
                resolve(data)
            })
        },
        //作品保存完成
        saveWorksAccomplish(id) {
            console.log(id)
            this.definedMsg('stuSaveWorkAccomplish', 'fn', this.classData.teacherId, id)
        },
        //加载设置
        defaultSettings(obj) {
            let setting = JSON.parse(obj)
            console.log(setting)
            this.enableChat = setting.fullChat;
            // console.log(this.stuRemoteStreamList)
            // this.handlerStuAudio(setting.fullUnmute);
            // this.chatSwitch(setting.fullChat)
            // this.handlerStuTab(setting.lessonTab);
            // if(setting.platformStuId && !this.platformStatus) {
            //     this.studentPlatform(`${setting.platformStuId},true`)
            // }
        },
        //处理指令消息
        dealDirectiveMsg(fromUserId, text) {
            console.log(fromUserId, text)
            if(fromUserId && fromUserId != this.userLogin.userId) {
                let arr = text.split('#');
                console.log(arr)
                if(this[arr[2]]) {
                    this[arr[2]](arr[3]? arr[3] : '', arr[5]? arr[5] : '');
                }
            }
        },
        //加载作品
        stuLoadWork(id) {
            if(this.lessonType == 'scratch') {
                console.log(id)
                this.currentWorkId = id;
                if(this.promptChanged) {
                    // this.promptShow = true;
                    this.onSaveWork();
                    return;
                }
                this.loadWork();
            } else if(this.lessonType == 'python') {
                // this.promptShow = true;
                this.onSaveWork();
            }
        },
        //加载作品
        loadWork() {
            if(this.currentWorkId) {
                this.worksId = this.currentWorkId;
                this.timestamp = Date.parse(new Date());
                this.lessonTab = this.lessonType;
                this.currentWorkId = "";
            }
        },
        loadPythonCode(py) {
            console.log("loadPythonCode");
            if(this.currentPythonCode) {
                this.lessonTab = this.lessonType;
                let pyIframe = document.getElementById('pyIframe').contentWindow;
                pyIframe.setAnswer(this.currentPythonCode);
                this.currentPythonCode = "";
            }
        },
        //保存作品
        onSaveWork() {
            if(this.lessonType == 'scratch') {
                let scIframe = document.getElementById('scIframe').contentWindow;
                scIframe.postMessage(`saveWorks#${this.lessonName}`, '*'); 
            } else if(this.lessonType == 'python') {
                let pyIframe = document.getElementById('pyIframe').contentWindow;
                // pyIframe.postMessage(`saveWorks#${this.lessonName}`, '*'); 
                pyIframe.saveWork(this.lessonName);
            }
            // this.promptShow = false;
        },
        //不保存作品
        onUnSaveWork() {
            if(this.lessonType == 'scratch') {
                this.loadWork();
            } else if(this.lessonType == 'python') {
                this.loadPythonCode();
            }
            this.promptShow = false;
        },
        //取消
        onCancel() {
            this.promptShow = false;
            this.currentWorkId = "";
            this.currentPythonCode = "";
        },
        //奖励动画显示
        studentAnimation(url) {
            this.awardCardImg = url;
            this.$refs.cardAnimationRef.show();
        },
        //教师分享屏幕
        teacherStreamPublish(type) {
            if(type == 'screen')
                this.lessonTab = 'lesson';
            this.teacherStreamType = type;
            this.screenTnstruct = true;
        },
        //聊天
        chatSwitch(bool) {
            console.log(bool)
            this.enableChat = JSON.parse(bool);
        },
        //老师上传文件
        pushFile(params) {
            this.files.push({
                url: params.split('+')[0],
                name: params.split('+')[1]
            })
        },
        //跟随切换
        followTeacherTab(type, fid) {
            console.log('111111111111111111111111111111111111111111111', type)
            this.lessonTab = type;
            if(fid) {
                this.teduBoard.switchFile(`#${fid}`);
            }
            if(this.shareScreen) {
                this.shareScreen = false;
            }
            console.log(fid)
        },
    }
}
</script>
<style lang="scss">
.stuClassroom {
    width: 100%;
    height: 100%;
    background-color: #efefef;
    overflow: hidden;
    ul, ol, li {
        margin: 0;
        padding: 0;
    }
    .classroomBody {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
        height: calc(100% - 50px);
    }
    .flex_row {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .boardBox {
        position: relative;
        width: calc(100% - 290px);
        height: 100%;
        .masking {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 999;
        }
    }
    #video_wrap,
    .screenBox {
        width: 100%;
        height: 100%;
    }
    .screenBox div {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
        background-color: rgb(240, 240, 240) !important;
    }
    .screenBox div video {
        width: auto !important;
        max-width: 100%;
    }
    .userListBox {
        display: flex;
        flex-direction: column;
        width: 290px;
        height: 100%;
        padding: 0 5px;
        background-color: var(--theme-color);
        box-sizing: border-box;
    }
    .userListBox.shareScreen {
        position: absolute;
        top: 0px;
        right: -290px;
        transition: 0.5s all;
    }
    .userListBox.shareScreenHover {
        position: absolute;
        top: 0px;
        right: 0px;
        transition: 0.5s all;
    }
    .userListBox .sideBarTip {
        position: fixed;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 30px;
        height: 100px;
        color: #fff;
        font-size: 18px;
        text-align: center;
        line-height: 33px;
        background-color: rgba(0, 0, 0, 0.3);
        border-radius: 3px;
        cursor: pointer;
        z-index: 998;
    }
    #paint_box {
        display: flex;
        height: 100%;
    }
    #video_teacher_list {
        position: relative;
        display: flex;
        width: 100%;
        height: 180px;
        // background: #000;
        background-image: url(~@/assets/tic/tecdefault.png);
        background-size: 100%;
        background-repeat: no-repeat;
    }
    .teacher_video,
    .student_video {
        position: relative;
        width: 100%;
        height: 180px;
        box-sizing: border-box;
        border: 2px solid var(--theme-color);
        overflow: hidden;
    }
    .my_video {
        position: absolute;
        right: 0;
        top: 110px;
        width: 100px;
        height: 70px;
    }
    .my_video .student_control {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 30px;
        background: rgba(0, 0, 0, .5);
        z-index: 5;
    }
    .my_video .student_control img {
        width: 20px;
        margin: 5px;
        cursor: pointer;
    }
    .platform {
        position: relative;
        width: 100%;
        height: 180px;
        overflow: hidden;
    }
    .platform .my_video {
        position: relative;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 180px;
    }
    .teacher_name,
    .student_name {
        position: absolute;
        top: 0;
        left: 0;
        color: #fff;
        font-size: 13px;
        padding: 2px;
        background-color: rgba(0, 0, 0, .5);
        z-index: 5;
    }
    .student_control {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 50px;
        background: rgba(0, 0, 0, .5);
        z-index: 5;
    }
    .student_control img {
        width: 20px;
        margin: 15px;
        cursor: pointer;
    }
    .defaultShowIMG{
        width: 100%;
        height: 180px;
    }
    .functional_region {
        width: 100%;
        height: calc(100% - 180px);
        border: 2px solid var(--theme-color);
    }
    .functional_region.platformTrue {
        height: calc(100% - 360px);
    }
    .functional_region_tab {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        height: 35px;
    }
    .functional_region_tab .functional_region_tab——item{
        flex: 1;
        height: 35px;
        line-height: 35px;
        text-align: center;
        color: var(--theme-color);
        font-size: 14px;
        background-color: #fff;
        border: 1px solid var(--theme-color);
        cursor: pointer;
    }
    .functional_region_tab .functional_region_tab——item.active {
        color: #fff;
        background-color: var(--theme-color);
    }
    .functional_region_foot {
        height: 100px;
        background-color: var(--theme-color);
    }
    .functional_region_foot .functional_region_foot_tab { 
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 40px;
        user-select: none;
    }
    .functional_region_foot_tab span {
        display: inline-block;
        width: 28px;
        height: 28px;
        margin: 0 2px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        cursor: pointer;
    }
    .functional_region_foot_tab span.keyboardIcon {
        background-image: url(~@/assets/tic/keyboard.png);
    } 
    .functional_region_foot_tab span.voiceIcon {
        background-image: url(~@/assets/tic/voice.png);
    } 
    .functional_region_foot_tab span.picIcon {
        background-image: url(~@/assets/tic/pic.png);
    } 
    
    .handsBox {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 28px;
        height: 28px;
        background-color: #fff;
        border-radius: 50%;
    }
    .handsBox .svg-icon {
        width: 20px;
        height: 20px;
        color: var(--theme-color);
    }
    // .hands_btn_box {
    //     display: flex;
    //     flex-direction: row;
    //     justify-content: center;
    //     align-items: center;
    //     width: 50px;
    //     height: 40px;
    // }
    // .hands_btn {
    //     display: block;
    //     width: 40px;
    //     height: 40px;
    //     background-color: #fff;
    //     border: 5px solid var(--menuHover);
    //     border-radius: 50%;
    //     cursor: pointer;
    // }
    // .hands_btn img {
    //     width: 40px;
    //     height: 40px;
    // }
    // .commonBox {
    //     display: flex;
    //     flex-direction: row;
    //     justify-content: space-between;
    //     align-items: center;
    //     width: 100%;
    // }
    // .commonBox {
    //     display: flex;
    //     flex-direction: row;
    //     justify-content: flex-start;
    //     align-items: center;
    //     width: 100%;
    //     height: 60px;
    // }
    // .commonBox .el-button {
    //     padding: 10px;
    //     height: 54px;;
    // }
    .defaultBg {
        width: 100%;
        height: 100%;
        vertical-align: initial;
    }
    // .textAreaBox {
    //     display: flex;
    //     flex-direction: row;
    //     justify-content: space-between;
    //     align-items: center;
    //     width: 100%;
    //     height: 100%;
    // }
    // .textAreaBox img {
    //     width: 20px;
    //     height: 20px;
    // }
    // .textAreaBox .prevBtn {
    //     display: flex;
    //     flex-direction: column;
    //     justify-content: center;
    //     align-items: center;
    //     width: 25px;
    //     height: 100%;
    //     background-color: #fff;
    // }
    
}
</style>


// WEBPACK FOOTER //
// src/views/classroom1/student.vue